import script from "./NoBsPromotionTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoBsPromotionTerminal.vue?vue&type=script&setup=true&lang=js"

import "./NoBsPromotionTerminal.vue?vue&type=style&index=0&id=2e485d04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e485d04"]])

export default __exports__